import { render, staticRenderFns } from "./LetGetStarted.vue?vue&type=template&id=dd046246&scoped=true&"
import script from "./LetGetStarted.vue?vue&type=script&lang=js&"
export * from "./LetGetStarted.vue?vue&type=script&lang=js&"
import style0 from "./LetGetStarted.vue?vue&type=style&index=0&id=dd046246&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd046246",
  null
  
)

export default component.exports